<mat-card class="summary-card">
  <div class="summary-title" style="background: #f58220;margin-bottom: 10px;">DAY PART SALES BY DEPARTMENT</div>
  <canvas #dtShopTimeWiseSalesChart width="800" height="780" style="width:100%;max-width:100%"></canvas>
</mat-card>